const ExecutionStatus = {
    Unknown: 0,
    Failure: 1,
    Success: 2,
}

module.exports = ExecutionStatus;